import { Box, Button, Typography } from '@mui/material'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { queryClient } from '../../../../App'
import FormInput from '../../../../components/customElements/FormInput'
import RightDrawer from '../../../../components/customElements/RightDrawer/RightDrawer'
import { useGetReceiverModels } from '../../../../hooks/useGetReceiverModels'
import {
  closeModalFn,
  isModalOpen,
} from '../../../../utils/controllers/ModalController'
import StatusInfoAndEdit from './DrawersCommonComponents/StatusInfoAndEdit'

type OperatorToGuaranteeDrawerProps = {
  serviceStore: any
  ordersStore: any
}

const OperatorToGuaranteeDrawer = ({
  serviceStore,
  ordersStore,
}: OperatorToGuaranteeDrawerProps) => {
  const intl = useIntl()
  const { serviceInformationAccordionFormStore, toGuaranteeRepairOperatorFn } =
    serviceStore

  const incedentTypes = queryClient.getQueryData(['incedent-types'])
  const incedentTypeReasons = queryClient.getQueryData([
    'incedent-type-reasons',
  ])

  const { data: receiveresModels } = useGetReceiverModels()

  const handleCloseInfoDrawer = () => {
    closeModalFn['operator-to-guarantee-drawer']?.()
    serviceInformationAccordionFormStore.clear()
  }

  const disableSavedBtn =
    !serviceInformationAccordionFormStore.data.receiverModelId ||
    serviceInformationAccordionFormStore?.data?.receiverSerialNumber?.length !==
      23

  return (
    <RightDrawer
      open={isModalOpen['operator-to-guarantee-drawer']}
      onClose={handleCloseInfoDrawer}
      titleComp={
        <Box className={'fx-col'}>
          <Typography variant={'subtitle1'} color={'common.white'}>
            <FormattedMessage id={'Заявка на сервисное обслуживание'} />
          </Typography>
        </Box>
      }
      backButtonClick={handleCloseInfoDrawer}
      isReportDetailsOpen={null}
      loading={null}
      onTop={null}
      title={null}
    >
      {/* @ts-ignore */}
      <StatusInfoAndEdit
        ordersStore={ordersStore}
        currentServiceData={{}}
        hardCodeStatus={8}
        openRequestDetails={null}
        serviceStore={null}
      />
      <Box
        sx={{
          margin: '32px 16px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          paddingBottom: '32px',
        }}
      >
        {/* @ts-ignore */}
        <FormInput
          type='select'
          api={serviceInformationAccordionFormStore}
          propName={'receiverModelId'}
          label={intl.formatMessage({ id: 'Модель оборудования' })}
          fullWidth
          placeholder={'Модель оборудования'}
          items={receiveresModels.map((el: any) => ({
            key: `${el.name} - ${el.manufacturerName}`,
            value: el.id,
          }))}
          withoutErrorText={true}
        />
        {/* @ts-ignore */}
        <FormInput
          type='text'
          api={serviceInformationAccordionFormStore}
          propName={'receiverSerialNumber'}
          label={intl.formatMessage({ id: 'Серийный номер' })}
          fullWidth
          placeholder={'Серийный номер'}
          withoutErrorText={true}
          inputProps={{
            maxLength: 23,
          }}
          error={
            serviceInformationAccordionFormStore?.data?.receiverSerialNumber
              ?.length !== 23
          }
          onlyNumbers
        />
        <Button
          variant='contained'
          sx={{ marginTop: '32px' }}
          onClick={() =>
            toGuaranteeRepairOperatorFn(incedentTypes, incedentTypeReasons)
          }
          disabled={disableSavedBtn}
        >
          Гарантийное обслуживание
        </Button>
      </Box>
    </RightDrawer>
  )
}

export default inject('serviceStore')(observer(OperatorToGuaranteeDrawer))
